import React from "react";
import { Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import CreatorDetails from "./creatorDetails";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { ChangeRequestStatus } from "../../../constants/Status";
import { withTranslation } from "react-i18next";

const ApprovalUpdate = ({ item, t }) => {
    return (
        <React.Fragment>
            <div className="mx-2">
                <div>
                    <strong> {ucFirst(Modules.APPROVAL)} </strong>
                    {t('was updated for')} <strong>{t('change request')} ({item?.payload?.moduleDetails?.uniqueChangeRequestId})</strong>
                    <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                </div>
                <div>
                    {item?.payload?.currentApprovalUser &&
                        typeof item?.payload?.currentApprovalUser === 'object' &&
                        (
                            <div className="mx-2">
                                {item?.payload?.currentApprovalUser?.new !== null && item?.payload?.currentApprovalUser?.old !== null &&
                                    <>
                                        <div className="d-flex align-items-center change_status">
                                            <span><strong>{item?.payload?.currentApprovalUser?.old?.user?.role?.name} [{item?.payload?.currentApprovalUser?.old?.user?.name} | {item?.payload?.currentApprovalUser?.old?.user?.uniqueUserId}]</strong>
                                                &nbsp;{t('approved the')} <strong> {t('change request')} ({item?.payload?.moduleDetails?.uniqueChangeRequestId})</strong></span>
                                        </div>
                                        <div className="d-flex align-items-center change_status">
                                            <span>{t('Approval is pending from')} <strong>{item?.payload?.currentApprovalUser?.new?.user?.role?.name} [{item?.payload?.currentApprovalUser?.new?.user?.name} | {item?.payload?.currentApprovalUser?.new?.user?.uniqueUserId}]</strong>
                                            </span>
                                        </div>
                                    </>
                                }
                                {item?.payload?.currentApprovalUser?.new !== null && typeof item?.payload?.currentApprovalUser?.new === 'object' && item?.payload?.currentApprovalUser?.old === null &&
                                    <>
                                        <div className="d-flex align-items-center change_status">
                                            <span>{t('Approval is pending from')} <strong>{item?.payload?.currentApprovalUser?.new?.user?.role?.name} [{item?.payload?.currentApprovalUser?.new?.user?.name} | {item?.payload?.currentApprovalUser?.new?.user?.uniqueUserId}]</strong>
                                            </span>
                                        </div>
                                    </>
                                }
                            </div>
                        )}
                    {item?.payload?.status &&
                        typeof item?.payload?.status === 'object' &&
                        (
                            <div className="mx-2">
                                <div className="d-flex align-items-center change_status">
                                    <div className="d-flex align-items-center change_status">
                                        {item?.payload?.status?.new === ChangeRequestStatus.REJECTED &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>Change request is rejected by <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                        {item?.payload?.status?.new === ChangeRequestStatus.APPROVED &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>Change request is approved by <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                        {item?.payload?.status?.new === ChangeRequestStatus.IN_APPROVAL &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>Change request is sent for approval by <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(ApprovalUpdate);
